export default __webpack_public_path__ + "../staticImages/bvg_icon.png";